module.exports = __webpack_public_path__ + "static/img/MobTech.6f18f78d.png";